export const LOGS_PROTECTED_SESSION_KEY = 'unit1-logs-protected-authenticated';

export function isLogsProtectedAuthenticated(): boolean {
  try {
    return sessionStorage.getItem(LOGS_PROTECTED_SESSION_KEY) === 'true';
  } catch {
    return false;
  }
}

export function grantLogsProtectedAccess(): void {
  sessionStorage.setItem(LOGS_PROTECTED_SESSION_KEY, 'true');
}

export function revokeLogsProtectedAccess(): void {
  sessionStorage.removeItem(LOGS_PROTECTED_SESSION_KEY);
}
